import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

/** The one empty-state block — an optional icon, a title and an optional hint,
 *  optionally in a dashed card. Callers position it (centred, in a table cell,
 *  …) via `className`. */
export function EmptyState({
  icon,
  title,
  hint,
  bordered,
  className,
}: {
  icon?: ReactNode
  title: ReactNode
  hint?: ReactNode
  bordered?: boolean
  className?: string
}) {
  return (
    <div
      className={cn(
        'text-muted-foreground flex flex-col items-center gap-1.5 text-sm',
        bordered && 'border-border-strong rounded-xl border border-dashed p-10',
        className,
      )}
    >
      {icon}
      <span>{title}</span>
      {hint && <span className="text-faint-foreground text-[11px]">{hint}</span>}
    </div>
  )
}
